import { connect } from 'react-redux'
import Revenue from '../views/Revenue'
import { 
  listRevenue, getUnionsFee, getGamesFee, saveCostList, getSuperAgentsFee, getUnionMembership, 
  getMembershipData, listR2HRevenue, fetchNoteToServer, getFlashLevelData, getAgentTaxEventList
      } from '../action/userAction'


function mapStateToProps (state, ownProps) {
  let revenue = state.getIn(['data','revenue']);
  let unions_col = state.getIn(['data','unions_col']);
  let unions_fee = state.getIn(['data','unions_fee']);
  let games_col = state.getIn(['data','games_col']);
  let games_fee = state.getIn(['data','games_fee']);
  let main_club = state.getIn(['data','main_club']);
  let super_agents = state.getIn(['data','super_agents']);
  let super_agents_fee = state.getIn(['data','super_agents_fee']);
  let union_membership_amount = state.getIn(['data','union_membership_amount']);
  let membership_header = state.getIn(['data','membership_header']);
  let membership_sum = state.getIn(['data','membership_sum']);
  let r2h_revenue = state.getIn(['data','r2h_revenue']);
  let user = state.getIn(['data','user']);
  let cm_detail = state.getIn(['data','cm_detail']);
  let flash_level_data = state.getIn(['data','flash_level_data']);
  let flash_level_col = state.getIn(['data','flash_level_col']);
  let agent_tax_event_list = state.getIn(['data','agent_tax_event_list']);
  let fetch_status = state.getIn(['data','fetch_status']);

  return {
    revenue: revenue,
    unions_col: unions_col,
    unions_fee: unions_fee,
    games_col: games_col,
    games_fee: games_fee,
    main_club: main_club,
    super_agents: super_agents,
    super_agents_fee: super_agents_fee,
    union_membership_amount: union_membership_amount,
    membership_header:membership_header,
    membership_sum:membership_sum,
    r2h_revenue : r2h_revenue,
    user: user,
    cm_detail : cm_detail,
    flash_level_data : flash_level_data,
    flash_level_col : flash_level_col,
    agent_tax_event_list : agent_tax_event_list,
    fetch_status : fetch_status,
    // main_clubs: main_club.clubs,
    // main_clubs_sum_data: main_club.sumData
  };
  
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onLoad:() =>{
      dispatch(listRevenue());
    },
    getUnionsFee:() =>{
      dispatch(getUnionsFee());
    },
    getGamesFee:() =>{
      dispatch(getGamesFee());
    },
    getSuperAgentsFee:() =>{
      dispatch(getSuperAgentsFee());
    },
    getMembershipData:() =>{
      dispatch(getMembershipData());
    },
    getUnionMembership:() =>{
      dispatch(getUnionMembership());
    },
    onSaveCostList:(id,costList) =>{
      dispatch(saveCostList(id,costList));
    },
    loadRake2HighData:() =>{
      dispatch(listR2HRevenue());
    },
    saveNoteToServer: (rowId, noteContent) => {
      dispatch(fetchNoteToServer(rowId, noteContent));
    },
    getFlashLevelData : () => {
      dispatch(getFlashLevelData());
    },
    getAgentTaxEventList: (weekString) => {
      dispatch(getAgentTaxEventList(weekString));
    }
})

const RevenueContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Revenue)

export default RevenueContainer